<!--
 창고FAQ > 제목 수정 컴포넌트
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical app-width-90per">

            <div class="uk-modal-header">
                <h4>제목 수정</h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <app-input-ex
                    class="uk-margin"
                    type="text"
                    v-model="title"
                ></app-input-ex>
            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>

                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },


        },
        data: function () {
            return {
                /**
                 * (object) 창고FAQ 오브젝트
                 **/
                warehouse_faq: null,

                /**
                 * (string) 제목
                 */
                title: null,
            };
        },
        computed: {

        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param warehouse_faq_id 창고FAQID
             */
            form(warehouse_faq_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/warehouse_faqs/' + warehouse_faq_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.warehouse_faq = response.warehouse_faq;
                    this.title = this.warehouse_faq.title;


                    // 폼띄우기
                    this.show();
                });
            },

            /**
             * submit
             */
            submit() {

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/warehouse_faqs/' + this.warehouse_faq.id + '/title',
                    data: {
                        '_token': this.csrfToken,
                        'title': this.title,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>